import React from 'react';
import { useDispatch } from 'react-redux';
import Modal from '../Modal/Modal';
import { manageDisableScrolling } from '../../ducks/ui.duck';
import css from './SupplierInformationModal.module.css';
import { useIntl } from 'react-intl';

const SupplierInformationModal = ({ isOpen, onClose, supplierId, supplierName }) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  return (
    <Modal
      id="SupplierInformationModal"
      isOpen={isOpen}
      onClose={onClose}
      usePortal
      onManageDisableScrolling={(componentId, disableScrolling) =>
        dispatch(manageDisableScrolling(componentId, disableScrolling))
      }
    >
      <div className={css.modalDetails}>
        <div className={css.supplierRow}>
          <span className={css.label}>
            {formatMessage({ id: 'SupplierInformationModal.supplierNameHeading' })}
          </span>
          <span className={css.value}>{supplierName}</span>
        </div>
        <div className={css.supplierRow}>
          <span className={css.label}>
            {formatMessage({ id: 'SupplierInformationModal.supplierIdHeading' })}
          </span>
          <span className={css.value}>{supplierId}</span>
        </div>
      </div>
    </Modal>
  );
};

export default SupplierInformationModal;
